import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const MeetingRoom24 = (props: SvgProps) => (
  <Svg
    width={25}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      d="M2 6.99951L2.87735 13.1409C2.94772 13.6336 3.36965 13.9995 3.8673 13.9995H9"
      stroke="#3379BD"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M22.3984 6.99951L21.5211 13.1409C21.4507 13.6336 21.0288 13.9995 20.5311 13.9995H15.3984"
      stroke="#3379BD"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <Path
      d="M18.5967 13.999V16.999M18.5967 16.999L16.0967 17.999M18.5967 16.999L21.0967 17.999"
      stroke="#3379BD"
      strokeWidth="2"
      strokeLinecap="round" />
    <Path
      d="M5.79883 13.999V16.999M5.79883 16.999L8.29883 17.999M5.79883 16.999L3.29883 17.999"
      stroke="#3379BD"
      strokeWidth="2"
      strokeLinecap="round" />
    <Path
      d="M5.7002 9.99951H12.2002M18.7002 9.99951H12.2002M12.2002 9.99951V16.9995"
      stroke="#3379BD"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </Svg>
);

export default MeetingRoom24;
